import {createI18n} from 'vue-i18n';
import it from '@/translation/it.json';
import en from '@/translation/en.json';

export const i18n = createI18n({
    locale: 'it',
    messages: {it, en},
    fallbackLocale: 'en'
});
export default i18n;